<template>
    <div class="pr form-item mt1">
        <label class="cf login-db">
          <svg class="login-icon "><use xlink:href="#password"/></svg>
            <input class="mr code-inp" type="tel" name="pwd" maxlength="4" required="required" pattern="\d{4}" data-required="请填写短信验证码" data-pattern="短信验证码填写错误" v-model="sms" placeholder="请输入验证码"/>
        </label>
        <input type="button" class="cms-btn" name="cms-btn" :disabled="!telReady" :value="cmsButtonText" @click="cmsClick" />
    </div>
</template>

<script>
export default {
    props:{
        /* type:0表示注册，1表示登录,2表示修改密码 */
       type:{
           type:Number,
           default:1
       },
       tel:{
           type:String,
           default:""
       },
       imgCode:{
           type:String,
           default:""
       },
       value:{
           type:String,
           default:""
       }
    },
    data(){
        return {
            api:"api/user-sendajax",
            sms:"",

            telReady:this.type===2,  //修改密码时用（修改密码时，不用传手机号）,该功能已经取消
            cmsButtonText:"获取验证码",
            cmsIsSending:false,
            countDownSecond:60
        };
    },
    watch:{
        tel(value){
            if(this.cmsIsSending)return;
            this.telReady=/^1\d{10}$/.test(value);
        },
        sms(value){
            this.$emit("input",value);
        }
    },
    methods:{
        countdown(time){
            if(time)
            {
               this.cmsButtonText="重发("+time+"s)";
               setTimeout(function(){
                   this.countdown(--time);
               }.bind(this),1000);
            }
            else
            {
                this.cmsButtonText="发送验证码";
                this.telReady=true; 
                this.cmsIsSending=false;
            }
        },
        cmsClick(e){
             var tel=this.tel;
             e.preventDefault();
             e.stopPropagation();
             if(this.type!==2){
                 this.telReady=false;
             }
             this.cmsIsSending=true;
            
            //mobile {手机号} type{值为1或0 0代表注册，1代表登录}
             this.$http.post(this.api,{"mobile":tel,"type":this.type}).then(res=>{
                    var j=res.data;
                    if(j.code===200){
                        //localStorage.setItem("countdown",Date.now());
                        this.$tip(j.data);
                        this.countdown(this.countDownSecond);
                    }else{
                        //alert(data.error);
                        this.$tip(j.error);
                        this.cmsIsSending=false;
                        this.telReady=true;
                    }
                },()=>{
                    this.$tip("系统繁忙请稍后重试");
                    this.cmsIsSending=false;
                    this.telReady=true;
                });

        }
    }
};
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/login/cms-item.vue